var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStackOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.655 15.075v-4.268h1.425V16.5H1.229v-5.693h1.419v4.268h10.008Zm-8.583-1.421h7.162v-1.425H4.072v1.425Zm.175-3.235 6.988 1.458.299-1.38L4.55 9.042l-.303 1.378Zm.906-3.37 6.47 3.019.601-1.3-6.468-3.02-.602 1.292-.001.01Zm1.81-3.19L12.44 8.43l.906-1.082L7.87 2.781l-.902 1.075-.005.004ZM10.499.5l-1.163.862 4.27 5.736 1.164-.861L10.5.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStackOverflow);
export default __webpack_public_path__ + "static/media/icon-stack-overflow.057f2dca89ca144e52f22405bde306d5.svg";
export { ForwardRef as ReactComponent };